import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { HTMLAsset, useAsset } from '@techstyle/react-assets';
import { FormattedMessage } from '@techstyle/react-intl';

import { mobile } from '../../styles';

const ConfidenceContainer = styled.div`
  ${props =>
    props.isPreorderable && `margin-top: ${props.theme.spacing.moderate}px;`}

  ${mobile`
    margin: 0 ${props => props.theme.spacing.small}px;
  `}
`;

const ConfidenceTitle = styled.div`
  padding: 12px ${props => props.theme.spacing.small}px;
  background-color: ${props => props.theme.colors.lavender200};
  text-align: center;

  ${({ theme }) => theme.paragraph.variants.paragraph3Uppercase.textStyles}
`;

const CondfidenceAssets = styled.div`
  padding: ${props => props.theme.spacing.small}px
    ${props => props.theme.spacing.small}px 0
    ${props => props.theme.spacing.small}px;

  background-color: ${({ theme }) => theme.colors.lavender100};
  padding-bottom: ${({ theme }) => theme.spacing.tiny}px;
`;

const SingleConfidenceAsset = styled.div`
  margin-bottom: ${props => props.theme.spacing.small}px;
  display: flex;
  align-items: center;
`;

const ConfidenceImage = styled.img`
  width: 50px;
`;

const ConfidenceText = styled(HTMLAsset)`
  margin-left: ${props => props.theme.spacing.tiny}px;
  overflow-wrap: break-word;

  ${({ theme }) => theme.paragraph.variants.paragraph3.textStyles}
  color: ${({ theme }) => theme.colors.gunmetal};

  strong {
    ${({ theme }) => theme.paragraph.variants.paragraph3Uppercase.textStyles}
    color: ${({ theme }) => theme.colors.black};
  }
`;

function ProductDetailConfidence({ className, isPreorderable }) {
  const assetContainerConfidence = useAsset('pdp_shopping_confidence_icons', {
    multi: true,
  });
  const { data } = assetContainerConfidence;
  const assetsConfidence = data ? data.assets : [];

  if (!assetsConfidence) {
    return null;
  }
  if (assetsConfidence && assetsConfidence.length) {
    return (
      <ConfidenceContainer
        className={className}
        isPreorderable={isPreorderable}
      >
        <ConfidenceTitle>
          <FormattedMessage
            id="site_pdp.confidence_title"
            defaultMessage="Shop with confidence"
          />
        </ConfidenceTitle>
        <CondfidenceAssets>
          {assetsConfidence.map((asset, index) => {
            // Shop With Confidence should only display
            // the first 3 assets that have been prioritized.
            if (index >= 3) {
              return;
            }

            const { id, imageFilename } = asset;
            return (
              <SingleConfidenceAsset key={id}>
                <ConfidenceImage src={imageFilename} alt="ConfidenceIcon" />
                <ConfidenceText asset={asset} />
              </SingleConfidenceAsset>
            );
          })}
        </CondfidenceAssets>
      </ConfidenceContainer>
    );
  }
  return null;
}

ProductDetailConfidence.propTypes = {
  className: PropTypes.string,
  isPreorderable: PropTypes.bool,
};

export default ProductDetailConfidence;
